<ng-container *ngIf="isStandalone">
  <p>
    You are updating preferences for the account associated with
    {{ userEmail }}, {{ userPhoneNumber }}.
  </p>
</ng-container>

<div class="updates-container">
  <hfc-updates-container
    [isEssential]="true"
    [updatesTitle]="'Essential Updates'"
    [commsPreferences]="commsPreferences"
    (importantUpdatesChanged)="onImportantUpdatesChanged($event)"
    (showPaperlessGraphic)="onUpdatesChanged($event)"
  ></hfc-updates-container>
  <hfc-updates-container
    [isEssential]="false"
    [updatesTitle]="'Optional Updates'"
    [commsPreferences]="commsPreferences"
    (optionalUpdatesChanged)="onOptionalUpdatesChanged($event)"
    (showPaperlessGraphic)="onUpdatesChanged($event)"
  ></hfc-updates-container>
</div>

<ng-container *ngIf="isStandalone">
  <footer class="contact-preference_footer">
    <div class="paperless-container">
      <hfc-button type="primary" (click)="updateContactPreferencesStandalone()">Update Preferences</hfc-button>
      <ng-container *ngIf="showPaperlessGraphic">
        <hfc-paperless-graphic [isPaperless]="isPaperless"></hfc-paperless-graphic>
      </ng-container>
    </div>

    <p class="privacy-policy" *ngIf="privacyPolicyUrl">
      See our
      <a [href]="privacyPolicyUrl" class="link-bold" target="_blank">Privacy Policy</a>
      to learn how we process your data.
    </p>
  </footer>
</ng-container>
